module.exports = __webpack_public_path__ + "img/image-13.53b999e4.jpg";